import React , {useState} from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Cover from '../../components/cover/Cover';
import Actions from '../MyItems/Actions';
import ListMyArtists from './ListMyArtists';

const MyArtists = () => {

    return (
        <div>
            <Header />
            <Cover
                title="Your Artists"
                subtitle="Profile | Artists | Mint"
            />

            <section className="tf-activity s1 tf-section">
                <div className="themesflat-container">
                    <div className="row ">
                        <div className="col-lg-8 col-md-8 col-12">
                            <ListMyArtists/>
                        </div>
                        <div className="col-lg-4 col-md-4 col-12">

                            <Actions />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default MyArtists;
